module.exports = __webpack_public_path__ + "static/media/location.257f5323.png";